export interface Article {
  id: string;
  title: string;
  categoryId: string;
  excerpt: string;
  content: string;
  image: string;
  date: string;
  author: string;
  tags: string[];
  readTime: number;
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "2026年最值得收藏的10款效率工具，助你事半功倍",
    categoryId: "cat-1",
    excerpt: "精心筛选了今年最实用的效率工具，涵盖任务管理、笔记协作、时间追踪等多个维度，每一款都经过实测验证，真正能提升你的工作效率。",
    content: `<p>在信息爆炸的时代，找到真正好用的工具并不容易。我们花了整整一个月的时间，从上百款工具中筛选出这10款真正值得收藏的效率工具。</p>
<h2>1. Notion - 全能型工作空间</h2>
<p>Notion已经成为了许多人日常工作不可或缺的工具。它将文档、数据库、任务管理、维基等功能融为一体，让你在一个平台上完成所有工作。2026年的更新更是加入了AI辅助功能，可以帮你自动总结、翻译、甚至生成内容草案。</p>
<p>对于团队协作来说，Notion的数据库视图功能尤其强大。你可以用看板管理项目进度，用日历规划内容排期，用表格整理数据信息——所有视图共享同一套数据，修改实时同步。</p>
<h2>2. Raycast - Mac用户的效率神器</h2>
<p>如果说Spotlight是Mac的标配搜索工具，那Raycast就是它的超级进化版。除了快速启动应用和搜索文件，Raycast还支持剪贴板历史、窗口管理、代码片段、快捷翻译等数十种扩展功能。</p>
<p>最令人惊喜的是它的扩展商店，社区贡献了上千款扩展，从GitHub操作到Notion搜索，从颜色提取到时区转换，几乎覆盖了你能想到的所有效率场景。</p>
<h2>3. Readwise - 让阅读更有价值</h2>
<p>Readwise解决了读书笔记最大的痛点：记了笔记却从来不看。它会自动从Kindle、Apple Books、Twitter、Pocket等平台同步你的高亮和标注，然后以间隔重复的方式每日推送给你复习。</p>
<p>2026年新增的Reader功能更是将RSS阅读和稍后读整合在一起，你可以在阅读文章时直接标注重点，这些标注会自动进入复习循环。</p>
<h2>总结</h2>
<p>好的工具不在于多，而在于真正融入你的工作流。建议从最需要解决的问题出发，选择1-2款工具深度使用，而不是一次性安装所有推荐。工具是手段，效率才是目的。</p>`,
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20and%20notebook%20on%20clean%20wooden%20desk%2C%20warm%20natural%20lighting%2C%20coffee%20cup%2C%20organized%20desk%20setup%2C%20soft%20shadows%2C%20editorial%20photography%2C%20neutral%20warm%20tones%2C%20professional%20yet%20cozy%20atmosphere&width=800&height=450&seq=article-tools-01&orientation=landscape",
    date: "2026-07-28",
    author: "91精选编辑",
    tags: ["效率工具", "生产力", "工具推荐"],
    readTime: 8,
    featured: true,
  },
  {
    id: "article-2",
    title: "设计师私藏的5个免费素材网站，高清无版权",
    categoryId: "cat-2",
    excerpt: "还在为找素材发愁？这5个免费可商用的素材网站，涵盖图片、插画、图标、字体等，质量堪比付费素材，设计师都悄悄收藏了。",
    content: `<p>作为一名设计师，找素材是日常工作中最耗时却又无法避免的环节。好的素材能极大提升设计品质，但付费素材的价格往往让人望而却步。今天分享5个我私藏已久的免费素材网站，每一个都经过长期使用验证。</p>
<h2>1. Unsplash - 高质量摄影图片</h2>
<p>Unsplash拥有超过300万张高质量图片，全部免费可商用。它的图片风格偏向艺术化和生活化，非常适合用作网站背景、社交媒体封面和品牌宣传。2026年新增的AI搜索功能可以更精准地帮你找到想要的图片。</p>
<h2>2. Humaaans - 插画人物素材</h2>
<p>如果你需要现代感十足的插画人物，Humaaans是最好的选择。它提供了可自定义的矢量人物组件，你可以自由组合发型、服装、姿势等元素，创造出独一无二的插画场景。</p>
<h2>3. The Noun Project - 图标资源库</h2>
<p>超过500万个图标，覆盖几乎所有领域。免费用户需要在使用时标注出处，付费版则无需标注。图标的统一性和风格一致性做得非常好，适合UI设计、演示文稿和信息图表。</p>
<h2>总结</h2>
<p>以上5个网站的素材均支持免费可商用，但建议使用前仔细阅读各自的授权协议。好的设计始于好的素材，收藏这些网站能让你的创意表达更加自如。</p>`,
    image: "https://readdy.ai/api/search-image?query=Creative%20designer%20workspace%20with%20color%20palette%20swatches%20and%20sketchbook%2C%20minimal%20aesthetic%2C%20warm%20ambient%20light%2C%20artistic%20tools%20arranged%20neatly%2C%20clean%20composition%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20style&width=800&height=450&seq=article-design-01&orientation=landscape",
    date: "2026-07-25",
    author: "91精选编辑",
    tags: ["设计素材", "免费资源", "设计师"],
    readTime: 6,
    featured: true,
  },
  {
    id: "article-3",
    title: "深入理解React 19的并发特性：实战指南",
    categoryId: "cat-3",
    excerpt: "React 19带来了全新的并发渲染机制，本文通过实战案例深入解析useTransition、useDeferredValue等API的正确使用姿势。",
    content: `<p>React 19的正式发布标志着React在并发渲染领域迈出了重要一步。虽然并发模式的概念早在React 18就引入了，但19版本对其进行了大量优化和稳定化处理。</p>
<h2>什么是并发渲染？</h2>
<p>简单来说，并发渲染允许React在渲染过程中"暂停"和"恢复"，从而避免长时间渲染阻塞用户交互。这就像你在写一篇文章时，可以随时停下来回复消息，然后再继续写作——而不是必须写完才能做其他事情。</p>
<h2>useTransition：标记低优先级更新</h2>
<p>useTransition是并发渲染最常用的API之一。它允许你将某些状态更新标记为"过渡"状态，React会降低这些更新的优先级，优先处理用户交互等紧急更新。</p>
<h2>useDeferredValue：延迟值的更新</h2>
<p>与useTransition标记状态更新不同，useDeferredValue用于标记某个值的更新可以延迟。这在搜索筛选等场景中特别有用——当用户快速输入时，不需要立即渲染每次输入对应的筛选结果。</p>
<h2>实战总结</h2>
<p>并发特性不是银弹，合理使用才能真正提升用户体验。关键原则是：把用户能直接感知的交互（点击、输入、动画）设为高优先级，把搜索建议、大列表渲染等后台任务设为低优先级。</p>`,
    image: "https://readdy.ai/api/search-image?query=Clean%20modern%20code%20editor%20on%20dark%20screen%20with%20syntax%20highlighting%2C%20minimal%20desk%20setup%2C%20warm%20ambient%20glow%2C%20developer%20workspace%2C%20soft%20shadows%2C%20professional%20tech%20aesthetic%2C%20neutral%20background&width=800&height=450&seq=article-tech-01&orientation=landscape",
    date: "2026-07-20",
    author: "91精选编辑",
    tags: ["React", "前端开发", "JavaScript"],
    readTime: 12,
    featured: true,
  },
  {
    id: "article-4",
    title: "2026年必读书单：从认知升级到实践方法论",
    categoryId: "cat-4",
    excerpt: "精选今年最值得阅读的12本书，跨越认知科学、商业思维、个人成长三大领域，每一本都能带来实质性的思维改变。",
    content: `<p>阅读是性价比最高的自我投资方式。一本好书带给你的认知升级，可能抵得上几年的摸爬滚打。今年的这份书单，我和多位行业前辈反复讨论后才最终确定。</p>
<h2>认知科学类</h2>
<p><strong>《思考，快与慢》</strong>——丹尼尔·卡尼曼的经典之作。这本书彻底改变了我对"思考"这件事的理解。系统1和系统2的划分不是抽象理论，而是能被你在日常生活中反复验证的认知模型。</p>
<p><strong>《原子习惯》</strong>——詹姆斯·克利尔用最简单的语言讲透了习惯养成的科学。读完你会发现，改变不需要意志力，需要的是正确的系统设计。</p>
<h2>商业思维类</h2>
<p><strong>《从0到1》</strong>——彼得·蒂尔关于创新和垄断的思考至今仍有启发。在竞争日益激烈的今天，学会寻找"秘密"比学会竞争更重要。</p>
<h2>总结</h2>
<p>读书不在于多，而在于思考和实践。建议每月精读1本书，做好笔记，定期回顾，把书中的方法论内化为自己的思维工具。这才是阅读的真正价值。</p>`,
    image: "https://readdy.ai/api/search-image?query=A%20stack%20of%20elegant%20hardcover%20books%20on%20a%20warm%20wooden%20table%2C%20soft%20reading%20lamp%20glow%2C%20reading%20glasses%20beside%20books%2C%20cozy%20library%20corner%2C%20warm%20amber%20lighting%2C%20minimalist%20composition%2C%20refined%20intellectual%20atmosphere&width=800&height=450&seq=article-learn-01&orientation=landscape",
    date: "2026-07-15",
    author: "91精选编辑",
    tags: ["书单推荐", "个人成长", "阅读"],
    readTime: 10,
    featured: false,
  },
  {
    id: "article-5",
    title: "番茄工作法过时了？试试这3种更科学的时间管理方法",
    categoryId: "cat-5",
    excerpt: "番茄工作法虽然经典，但并非适合所有人。本文介绍3种基于认知科学的时间管理新方法，帮你找到最适合自己的工作节奏。",
    content: `<p>番茄工作法自1990年代提出以来，一直是最流行的时间管理方法之一。但近年的认知科学研究表明，固定的25+5分钟节奏并不是最优的工作模式。</p>
<h2>为什么番茄法有时不管用？</h2>
<p>核心问题在于：不同任务的认知负荷差异巨大。写代码需要长时间深度沉浸，而回复邮件则更适合短平快的处理方式。一刀切的25分钟间隔，可能打断深度工作状态，又让简单任务显得拖沓。</p>
<h2>方法一：90分钟深度工作法</h2>
<p>基于人体"次昼夜节律"，我们的注意力天然以90分钟为周期波动。与其对抗这个规律，不如顺应它：安排90分钟的深度工作块，然后休息20-30分钟。</p>
<h2>方法二：时间分块法</h2>
<p>把一天分为若干主题块，每个块专注特定类型的工作。比如上午9-11点是创意工作块，下午2-4点是沟通协作块。这种方法保留了灵活性，同时确保了每类工作都有充足的专注时间。</p>
<h2>总结</h2>
<p>最好的时间管理方法是适合你的方法。建议每种方法试用一周，记录精力变化和工作产出，数据会告诉你哪个方法最适合你的工作节奏。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimal%20desk%20with%20analog%20clock%20and%20clean%20planner%20notebook%2C%20warm%20morning%20sunlight%20streaming%20through%20window%2C%20organized%20workspace%2C%20soft%20beige%20and%20cream%20palette%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-prod-01&orientation=landscape",
    date: "2026-07-10",
    author: "91精选编辑",
    tags: ["时间管理", "效率", "工作方法"],
    readTime: 7,
    featured: true,
  },
  {
    id: "article-6",
    title: "自媒体人必备的7个AI创作工具，内容产出效率翻倍",
    categoryId: "cat-1",
    excerpt: "从选题策划到内容生成，从图片制作到数据分析，这7个AI工具覆盖自媒体创作的完整流程，实测好用。",
    content: `<p>AI工具的快速发展正在彻底改变内容创作的方式。聪明的自媒体人已经开始把AI当作创作伙伴，而非替代品。以下是7个经过实测的AI创作工具。</p>
<h2>1. Claude - 深度内容创作助手</h2>
<p>在长文写作和深度分析方面，Claude是目前表现最好的AI助手。它擅长理解复杂的写作指令，能够保持文章的逻辑一致性和语气连贯性。用它来写大纲、拓展思路、润色文字都非常出色。</p>
<h2>2. Midjourney - AI图像生成</h2>
<p>配图是自媒体创作的一大痛点。Midjourney可以生成高质量的原创配图，从写实摄影风格到插画风格都能驾驭。最新的V7版本在细节表现和文字渲染方面有了质的飞跃。</p>
<h2>3. Descript - 视频内容编辑</h2>
<p>Descript把视频编辑变成了文字编辑——你只需要编辑转录文本，视频就会自动同步修改。对于需要频繁产出视频内容的自媒体人来说，这能节省大量剪辑时间。</p>
<h2>总结</h2>
<p>AI工具的价值不在于替代创作，而在于处理重复性工作，让你有更多精力投入到真正需要创造力的部分。关键是找到AI和人工创作的最佳结合点。</p>`,
    image: "https://readdy.ai/api/search-image?query=Futuristic%20minimal%20creative%20workspace%20with%20holographic%20interface%20and%20tablet%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20technology%20and%20creativity%20blended%2C%20soft%20neutral%20tones%2C%20modern%20professional%20environment&width=800&height=450&seq=article-ai-01&orientation=landscape",
    date: "2026-07-05",
    author: "91精选编辑",
    tags: ["AI工具", "自媒体", "内容创作"],
    readTime: 9,
    featured: false,
  },
  {
    id: "article-7",
    title: "2026年UI设计趋势：极简主义的回归与进化",
    categoryId: "cat-2",
    excerpt: "今年UI设计圈最值得关注的趋势解读：新极简主义、微交互设计、AI融合界面、无障碍设计等方向的发展与变化。",
    content: `<p>每年设计圈都会涌现新的趋势和风格，2026年也不例外。但与往年不同的是，今年的趋势更加强调"回归本质"——不是花哨的视觉效果，而是更好的用户体验。</p>
<h2>新极简主义</h2>
<p>极简主义从未真正离开，但今年的极简有了新的内涵。它不再是简单的"少即是多"，而是"恰到好处"。设计师开始更加慎重地考虑每一个元素存在的必要性，让界面回归内容本身。</p>
<h2>微交互的精细化</h2>
<p>微交互正在变得更加细腻和人性化。不再是机械的动画效果，而是模拟物理世界的质感——按钮的按压弹性、页面的惯性滚动、卡片的悬浮阴影变化，这些细节让数字界面有了"触感"。</p>
<h2>总结</h2>
<p>好的设计趋势不是用来盲目追随的，而是用来理解背后的设计理念。2026年的核心主题是"人性化"——让技术服务于人，而非人适应技术。</p>`,
    image: "https://readdy.ai/api/search-image?query=Minimalist%20UI%20design%20mockup%20displayed%20on%20a%20clean%20screen%2C%20warm%20neutral%20color%20palette%2C%20elegant%20typography%2C%20design%20studio%20background%20with%20soft%20lighting%2C%20modern%20creative%20workspace%2C%20refined%20aesthetic&width=800&height=450&seq=article-design-02&orientation=landscape",
    date: "2026-06-28",
    author: "91精选编辑",
    tags: ["UI设计", "设计趋势", "用户体验"],
    readTime: 7,
    featured: false,
  },
  {
    id: "article-8",
    title: "TypeScript 5.8 新特性全解析：类型系统的又一次进化",
    categoryId: "cat-3",
    excerpt: "TypeScript 5.8带来了多项实用的类型系统改进，包括条件类型优化、模板字面量类型增强等，本文全面解读每一个值得关注的新特性。",
    content: `<p>TypeScript 5.8的发布为类型系统带来了不少令人兴奋的改进。虽然版本号只是小版本更新，但实际的功能升级相当实用。</p>
<h2>条件类型推断优化</h2>
<p>5.8版本对条件类型的推断逻辑进行了显著优化。在复杂的泛型场景中，TypeScript现在能更准确地推断出条件类型的结果类型，减少了开发者手动类型断言的需求。</p>
<h2>模板字面量类型的增强</h2>
<p>模板字面量类型现在支持更复杂的字符串模式匹配。这意味着你可以在类型层面表达更精细的字符串约束，比如格式验证、路径解析等。</p>
<h2>性能提升</h2>
<p>除了功能改进，5.8在性能方面也有不小的提升。大型项目的类型检查速度平均提升了15-20%，这对于日常开发体验的改善是实实在在的。</p>
<h2>总结</h2>
<p>TypeScript的发展方向很明确：让类型系统更智能、更强大，同时保持编译性能。5.8是一个值得升级的版本。</p>`,
    image: "https://readdy.ai/api/search-image?query=Abstract%20programming%20code%20on%20dark%20screen%20with%20colorful%20syntax%20highlighting%2C%20modern%20developer%20environment%2C%20clean%20minimal%20setup%2C%20warm%20ambient%20glow%2C%20technical%20yet%20artistic%2C%20soft%20contrast&width=800&height=450&seq=article-tech-02&orientation=landscape",
    date: "2026-06-20",
    author: "91精选编辑",
    tags: ["TypeScript", "前端开发", "编程语言"],
    readTime: 11,
    featured: false,
  },
  {
    id: "article-9",
    title: "从零开始学摄影：构图法则与光线运用入门指南",
    categoryId: "cat-4",
    excerpt: "摄影入门最需要掌握的两大核心：构图和光线。本文用最简单易懂的方式，带你快速入门摄影的基础知识体系。",
    content: `<p>很多人以为摄影需要昂贵的设备才能开始。实际上，理解构图和光线这两大基础，比器材重要得多。用手机也能拍出好照片，关键在于你的"摄影眼"。</p>
<h2>三大基本构图法则</h2>
<p><strong>三分法</strong>：将画面用两条水平线和两条垂直线分成九等份，把主体放在交叉点上。这是最基础也最实用的构图方法，几乎适用于所有场景。</p>
<p><strong>引导线</strong>：利用场景中的线条（道路、栏杆、河流等）引导观众的视线走向主体。好的引导线能让照片产生强烈的纵深感。</p>
<p><strong>留白</strong>：在主体周围保留适当的空白空间。留白不是浪费画面，而是给主体"呼吸"的空间，让画面更有意境。</p>
<h2>光线的三个关键要素</h2>
<p>光线的方向、强度和色温决定了照片的氛围。黄金时段（日出后和日落前的一小时）是自然光最柔和、最富有表现力的时段。</p>
<h2>总结</h2>
<p>摄影是一门需要大量实践的艺术。建议每天拍10张照片，有意识地运用构图法则，一个月后你会发现自己的眼睛已经不一样了。</p>`,
    image: "https://readdy.ai/api/search-image?query=Vintage%20camera%20on%20a%20minimal%20wooden%20surface%20with%20soft%20golden%20hour%20sunlight%2C%20film%20strips%20and%20printed%20photos%20scattered%20artfully%2C%20warm%20nostalgic%20atmosphere%2C%20creative%20photography%20setup%2C%20editorial%20style&width=800&height=450&seq=article-photo-01&orientation=landscape",
    date: "2026-06-15",
    author: "91精选编辑",
    tags: ["摄影", "构图", "入门教程"],
    readTime: 8,
    featured: false,
  },
  {
    id: "article-10",
    title: "远程办公两年后的反思：我放弃了哪些'高效'习惯",
    categoryId: "cat-5",
    excerpt: "远程办公两年，我尝试了几乎所有号称高效的工作方法，最终发现有些看起来高效的习惯，实际上在拖慢我的节奏。",
    content: `<p>远程办公的这两年，我像很多人一样，沉迷于各种效率方法论。番茄钟、时间分块、GTD、看板管理……几乎所有流行的方法我都试过。但现在回头看，很多"高效"习惯反而是效率的敌人。</p>
<h2>我放弃的习惯一：严格的时间表</h2>
<p>一开始我给自己制定了精确到半小时的日程表。结果呢？每天都活在"落后于计划"的焦虑中。远程办公最大的优势就是灵活性，用严格的时间表反而扼杀了这个优势。</p>
<h2>我放弃的习惯二：过多的工具</h2>
<p>有段时间我的任务管理工具、笔记工具、日历工具各不相同，结果就是信息碎片化，找一条信息需要打开三个应用。现在我只用两个工具，简单反而高效。</p>
<h2>我坚持的习惯：每日复盘</h2>
<p>唯一坚持下来且真正有价值的习惯是每天花10分钟做复盘：今天做了什么、遇到了什么问题、明天计划做什么。这个简单的习惯帮我保持了清晰的思路和方向感。</p>
<h2>总结</h2>
<p>真正的效率不在于用多少方法、多少工具，而在于找到最适合自己节奏的工作方式。少即是多，简单才能持续。</p>`,
    image: "https://readdy.ai/api/search-image?query=Cozy%20home%20office%20corner%20with%20laptop%20and%20plant%2C%20warm%20natural%20light%20from%20large%20window%2C%20minimal%20decor%2C%20comfortable%20chair%2C%20calm%20working%20atmosphere%2C%20soft%20beige%20and%20green%20tones%2C%20editorial%20photography&width=800&height=450&seq=article-remote-01&orientation=landscape",
    date: "2026-06-08",
    author: "91精选编辑",
    tags: ["远程办公", "效率", "工作方式"],
    readTime: 9,
    featured: true,
  },
  {
    id: "article-11",
    title: "精选10款Mac必备软件，让你的Mac更好用",
    categoryId: "cat-6",
    excerpt: "从系统增强到效率工具，从设计利器到开发辅助，这10款软件是Mac用户的必备之选，大幅提升使用体验。",
    content: `<p>换了Mac之后，我发现好用的软件能极大地提升使用体验。以下10款软件是经过长期使用验证的Mac必备之选。</p>
<h2>Alfred - 效率启动器</h2>
<p>比Spotlight强大太多的启动器。除了快速启动应用和搜索文件，Alfred的工作流功能可以让你自定义各种快捷操作：一键搜索、剪贴板历史、代码片段管理等。</p>
<h2>CleanShot X - 截图工具</h2>
<p>这是我用过最好的截图工具。除了基础截图，它还支持滚动截屏、屏幕录制、标注编辑、云端分享。特别是截图后的标注功能，做教程和文档演示非常方便。</p>
<h2>总结</h2>
<p>好的软件应该让你感觉不到它的存在——它自然地融入工作流，让一切变得顺畅。以上推荐的软件都具有这样的特质。</p>`,
    image: "https://readdy.ai/api/search-image?query=Sleek%20MacBook%20Pro%20on%20minimal%20desk%20with%20clean%20setup%2C%20warm%20ambient%20lighting%2C%20modern%20coffee%20shop%20background%2C%20organized%20workspace%2C%20soft%20shadows%2C%20professional%20aesthetic%2C%20neutral%20warm%20tones&width=800&height=450&seq=article-mac-01&orientation=landscape",
    date: "2026-06-01",
    author: "91精选编辑",
    tags: ["Mac", "软件推荐", "效率"],
    readTime: 7,
    featured: false,
  },
  {
    id: "article-12",
    title: "Chrome扩展推荐：这8个插件让你的浏览器生产力翻倍",
    categoryId: "cat-6",
    excerpt: "精心挑选的8个Chrome浏览器扩展，涵盖标签管理、广告拦截、效率提升、隐私保护等多个方面，每一个都经过长期使用验证。",
    content: `<p>浏览器是我们每天使用时间最长的工具之一。合适的扩展可以极大提升浏览体验和工作效率。</p>
<h2>uBlock Origin - 广告拦截</h2>
<p>最轻量高效的广告拦截器，不仅拦截广告，还能屏蔽跟踪脚本和恶意网站。资源占用极低，不会拖慢浏览器速度。</p>
<h2>OneTab - 标签管理</h2>
<p>当你打开几十个标签页时，OneTab可以一键将所有标签收纳到一个列表中，释放内存的同时保持所有页面随时可恢复。</p>
<h2>总结</h2>
<p>扩展虽好，但不要贪多。每个扩展都会消耗系统资源，建议保持10个以内的精选扩展，定期清理不常用的。</p>`,
    image: "https://readdy.ai/api/search-image?query=Modern%20browser%20interface%20on%20a%20clean%20desktop%20screen%2C%20colorful%20extension%20icons%2C%20minimal%20workspace%2C%20warm%20ambient%20lighting%2C%20clean%20composition%2C%20professional%20tech%20environment%2C%20soft%20neutral%20tones&width=800&height=450&seq=article-chrome-01&orientation=landscape",
    date: "2026-05-25",
    author: "91精选编辑",
    tags: ["Chrome", "浏览器扩展", "效率工具"],
    readTime: 6,
    featured: false,
  },
];